module.exports = __webpack_public_path__ + "img/report-complaint.6ff50074.svg";